import {Injectable} from '@angular/core';
import {isNotNullOrUndefined} from "codelyzer/util/isNotNullOrUndefined";
import {HttpClient} from "@angular/common/http";
import { ConfigurationService } from '../configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class GMonService {
  private violationsJson = 'assets/gmon-violations.json';
  private configuration: any;

  constructor(
    private httpClient: HttpClient,
    private configurationService: ConfigurationService) {
      this.configuration = configurationService.getConfiguration();
  }

  // close() {
  //   this.socket.disconnect();
  // }

  isGMonRunning() {
    let isGMonRunning: boolean = false;

    const isGMonRunningStr: string = localStorage.getItem("isGMonRunning");
    if (isNotNullOrUndefined(isGMonRunningStr)) {
      if (isGMonRunningStr == "true") {
        isGMonRunning = true;
      }
    }
    return isGMonRunning;
  }

  setGMonRunning(isRunning: boolean) {
    localStorage.setItem("isGMonRunning", "" + isRunning);
  }


  setDataAvailable( key: string, areDataAvailable: boolean) {
    localStorage.setItem(key, "" + areDataAvailable);
  }

  areDataAvailable(key: string) {
    let areDataAvailable: boolean = false;

    const areDataAvailableStr: string = localStorage.getItem(key);
    if (isNotNullOrUndefined(areDataAvailableStr)) {
      if (areDataAvailableStr == "true") {
        areDataAvailable = true;
      }
    }
    return areDataAvailable;
  }

  areGMonDataAvailable() {
    let areDataAvailable: boolean = false;

    const areGMonDataAvailableStr: string = localStorage.getItem('areGMonDataAvailable');
    if (isNotNullOrUndefined(areGMonDataAvailableStr)) {
      if (areGMonDataAvailableStr == "true") {
        areDataAvailable = true;
      }
    }
    return areDataAvailable;
  }

  setGmonDataAvailable( areGMonDataAvailable: boolean) {
    localStorage.setItem('areGMonDataAvailable', "" + areGMonDataAvailable);
  }

}
